import { FC } from "react";

import Grid from "@mui/material/Grid";

import { TextFieldInputProps } from "./types";

export const TextFieldWithCopyWrapper: FC<
  TextFieldInputProps & { slots: { textFieldComponent: React.ReactNode; copyButtonComponent: React.ReactNode } }
> = ({ button = false, copyButtonBelow = false, hideCopyButton = false, slots }) => {
  const { textFieldComponent, copyButtonComponent } = slots;
  return (
    <Grid container alignItems={copyButtonBelow ? "flex-start" : "center"} spacing={copyButtonBelow ? 1 : 0}>
      <Grid item xs>
        {textFieldComponent}
      </Grid>

      {button && !copyButtonBelow && !hideCopyButton ? (
        <Grid item marginLeft={1}>
          {copyButtonComponent}
        </Grid>
      ) : undefined}

      {button && copyButtonBelow && !hideCopyButton ? (
        <Grid item xs={12} sx={{ marginTop: 1 }}>
          {copyButtonComponent}
        </Grid>
      ) : null}
    </Grid>
  );
};
